"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _reactPdf = require("react-pdf");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: 0,
      position: 'absolute',
      top: 72,
      right: 36,
      borderRadius: 0
    },
    dialog: {
      maxWidth: 1920
    }
  };
});

var CertificatePDF = function CertificatePDF(_ref) {
  var extraClasses = _ref.classes,
      src = _ref.src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 200 : _ref$width,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? 1.414285714 : _ref$ratio,
      onClick = _ref.onClick;
  var classes = useStyles({
    classes: extraClasses
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      pdfLoaded = _useState2[0],
      setPdfLoaded = _useState2[1];

  var doc = /*#__PURE__*/_react["default"].createElement(_reactPdf.Document, {
    file: src,
    onLoadSuccess: function onLoadSuccess() {
      return setPdfLoaded(true);
    },
    options: {}
  }, pdfLoaded ? /*#__PURE__*/_react["default"].createElement(_reactPdf.Page, {
    key: 'page_0',
    pageNumber: 1,
    width: width
  }) : null);

  return /*#__PURE__*/_react["default"].createElement(_core.Card, {
    elevation: 8,
    style: {
      width: width,
      height: width * ratio
    },
    className: classes.root
  }, onClick ? /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
    onClick: onClick
  }, doc) : doc);
};

CertificatePDF.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  certificate: _propTypes["default"].object.isRequired
};
CertificatePDF.defaultProps = {
  className: ''
};
var _default = CertificatePDF;
exports["default"] = _default;